/* eslint-disable no-console */
import {
  type DescMessage,
  type MessageShape,
  toJson,
} from '@bufbuild/protobuf';
import { Interceptor } from '@connectrpc/connect';
import { DEBUG_MODE_STORAGE_KEY } from '~/services/api/debug/debug-toggle';

let grpcDebugCallId = 0;

function messageToJson<T extends DescMessage>(
  schema: T,
  message: MessageShape<T>,
) {
  try {
    return toJson(schema, message);
  } catch {
    return message;
  }
}

export const grpcDebugMiddleware: Interceptor = (next) => async (req) => {
  const isDebugMode = localStorage.getItem(DEBUG_MODE_STORAGE_KEY) === 'true';

  if (!isDebugMode) {
    return next(req);
  }

  grpcDebugCallId += 1;
  const callId = grpcDebugCallId;
  const startedAt = performance.now();
  const requestLog = req.stream
    ? '[stream]'
    : messageToJson(req.method.input, req.message);

  try {
    const response = await next(req);
    const durationMs = Math.round(performance.now() - startedAt);
    const responseLog = response.stream
      ? '[stream]'
      : messageToJson(response.method.output, response.message);

    console.groupCollapsed(
      `[gRPC #${callId}] ${req.method.name} (${durationMs}ms)`,
    );
    console.log('Request:', requestLog);
    console.log('Response:', responseLog);
    console.groupEnd();

    return response;
  } catch (error) {
    const durationMs = Math.round(performance.now() - startedAt);

    console.groupCollapsed(
      `[gRPC #${callId}] ${req.method.name} (${durationMs}ms)`,
    );
    console.log('Request:', requestLog);
    console.error('Error:', error);
    console.groupEnd();
    throw error;
  }
};
